export const PLANS = [
  {
    id: "launch", name: "Launch", price: "£39", period: "/month", annual: "£390/year", annualNote: "2 months free", founding: "£29/month",
    tagline: "Perfect for small & independent businesses",
    audience: "Cafés, Coffee Shops, Pubs, B&Bs, Independent Restaurants",
    accent: "from-[#7CB342] to-[#AEEA00]", ring: "border-[#7CB342]/40", glow: "bg-[#7CB342]",
    groups: [
      { title: "Guest Experience", items: ["Online reservations", "Guest booking portal", "Dietary & allergy collection", "Capacity management"] },
      { title: "Operations", items: ["Complaint management", "Reception dashboard", "Default departments (Reception, Kitchen, F&B, Housekeeping, Maintenance)", "Up to 10 staff accounts", "One business location"] },
      { title: "Reporting", items: ["Reservation overview", "Complaint overview", "Basic operational reporting"] },
      { title: "Support", items: ["Standard email support"] },
    ],
    best: "Best suited for businesses beginning to digitise their operations.",
  },
  {
    id: "elevate", name: "Elevate", price: "£89", period: "/month", annual: "£890/year", annualNote: "2 months free", founding: "£59/month", popular: true,
    tagline: "For growing hospitality businesses",
    audience: "Restaurants, Boutique Hotels, Venues, Single Location Groups",
    plus: "Everything in Launch, plus:",
    accent: "from-[#A855F7] to-[#FF2A6D]", ring: "border-[#A855F7]/50", glow: "bg-[#A855F7]",
    groups: [
      { title: "Operations", items: ["Unlimited staff accounts", "Unlimited departments", "Custom departments", "Department managers", "Staff role permissions"] },
      { title: "Management", items: ["Management dashboard", "Complaint assignment workflow", "Department visibility", "Team performance monitoring"] },
      { title: "Reporting", items: ["Department reporting", "Staff performance", "Complaint trends", "Reservation insights"] },
      { title: "Support", items: ["Priority support"] },
    ],
    best: "Best suited for growing hospitality businesses that require full operational visibility.",
  },
  {
    id: "signature", name: "Signature", price: "From £199", period: "/month", annual: "from £1,990/year", annualNote: "2 months free", founding: "Custom introductory pricing",
    tagline: "For multi-site & enterprise operations",
    audience: "Hotel Chains, Resorts, Multi-site Restaurants, Hospitality Groups",
    plus: "Everything in Elevate, plus:",
    accent: "from-[#F6B73C] to-[#FF6B35]", ring: "border-[#F6B73C]/40", glow: "bg-[#F6B73C]",
    groups: [
      { title: "Enterprise Management", items: ["Multiple business locations", "Centralised management", "Multi-location reporting", "Enterprise dashboard"] },
      { title: "Business Support", items: ["Dedicated onboarding", "Customer success manager", "Early feature access"] },
      { title: "Enterprise Features", items: ["API integrations (future)", "Advanced reporting", "Custom enterprise solutions"] },
    ],
    best: "Best suited for hotels, groups and multi-site operations that need complete operational control.",
  },
];

export const INCLUDED = [
  "Online Reservations", "Capacity Management", "Guest Portal", "Staff Accounts",
  "Complaint Management", "Department Management", "Reception Dashboard", "Secure Business Portal",
  "Dietary & Allergy Capture", "Email Support",
];

export const VALUE_PROPS = [
  "Reduce negative online reviews by resolving issues before guests leave.",
  "Improve communication between Reception, Management and departments.",
  "Capture dietary requirements and allergies accurately.",
  "Increase accountability through department-specific workflows.",
  "Give management complete visibility over reservations, complaints and performance.",
  "Deliver a smoother, more consistent guest experience across the business.",
];

export const FOUNDING = [
  { name: "Launch", price: "£29/month" },
  { name: "Elevate", price: "£59/month" },
  { name: "Signature", price: "Custom introductory pricing" },
];
export const FOUNDING_NOTE = "Founding customers retain their introductory rate while their qualifying subscription remains active.";
export const TRIAL_NOTE = "Every new BeetDrop business can access the full platform for 30 days, with full platform access, no setup fee and no long-term contract.";

export const planMeta = (id) => PLANS.find((p) => p.id === id) || PLANS[0];
export const planName = (id) => planMeta(id).name;
